TYPE_CONTENT_REFERENCES_LIST